import script from "./set-display-info.vue?vue&type=script&lang=tsx&setup=true"
export * from "./set-display-info.vue?vue&type=script&lang=tsx&setup=true"

import "./set-display-info.vue?vue&type=style&index=0&id=0a189e88&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/.store/vue-loader@17.4.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a189e88"]])

export default __exports__